/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_LoadingInputs */

const en_google_drive_loading = /** @type {(inputs: Google_Drive_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading Google Drive…`)
};

const es_google_drive_loading = /** @type {(inputs: Google_Drive_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando Google Drive…`)
};

/**
* | output |
* | --- |
* | "Loading Google Drive…" |
*
* @param {Google_Drive_LoadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_loading = /** @type {((inputs?: Google_Drive_LoadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_LoadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_loading(inputs)
	return en_google_drive_loading(inputs)
});